<template>
  <div>
    <div class="px-8 d-flex text-subtitle-1 text--secondary" v-if="!isDiff">
      {{ routeText }}
    </div>

    <div
      v-else
      :class="$style.newBg"
      class="d-flex text-subtitle-1 align-center primary--text pl-2"
    >
      <v-icon small color="primary" class="pr-2">mdi-alert-octagram</v-icon>
      {{ showIsMissing ? 'Påverkade sträcka/sträckor saknas' : routeText }}
    </div>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'TrafficMessageRoutesText',

  computed: {
    event: get('event/selectedEvent'),
    stops: get('event/stops'),
    model: get('trafficMessage/model'),

    isDiff: get('trafficMessage/diffRoutesCount'),

    showIsMissing() {
      return this.isDiff && !this.routeText.length
    },

    routesUUIDs: get('trafficMessage/model@routes'),
    routeText() {
      if (!(this.event?.routes || []).length) return ''

      return this.event?.routes
        .map(x => {
          const findLocationName = signature =>
            (signature &&
              this.stops.find(x => x.short_name === signature)?.stop_name) ||
            '-'
          return `${findLocationName(x?.from_place)} - ${findLocationName(
            x?.to_place
          )}`
        })
        .join(', ')
    }
  }
}
</script>

<style lang="scss" module>
.newBg {
  background: rgba(#0034f9, 0.06);
}
</style>
